<template>
    <div class="modal buttonCancel" id="buttonCancel">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 rounded-0 p-0">
                <div role="alert">
                    <div class="modal-header border-0 d-flex align-items-start p-4">
                        <h3 class="text-start m-0 pe-2"><strong>Você tem certeza que deseja cancelar essa proposta?</strong>
                        </h3>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="p-3 pt-0">
                      <p class="mt-2 text-start">
                        Ao clicar em ‘Cancelar proposta’, essa proposta será cancelada. Por gentileza, entre em contato com o seu consultor para solicitar uma nova proposta.
                      </p>
                      <div class="text-end">
                        <button type="button" class="btn button-back-proposal w-10 fw-bold h-auto m-2" data-bs-dismiss="modal">
                          Voltar
                        </button>
                        <button type="button" class="btn button-conclude fw-bold" data-bs-dismiss="modal"
                        @click="$emit('cancel-proposal')">
                        Cancelar proposta
                      </button>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: "ModalCancelProposal"
};
</script>
<style scoped>


.modal-content {
  width: 80vw;
  max-width: 600px;
  max-height: 80vh;
}

.btn.button-conclude:hover {
  background: #d85a73;
  color: #ffff;
}

.btn.button-back-proposal {
  color: #11A7B6;
  max-height: 40px;
  border: 1px #9EA5AC solid;
  border-radius: 1px;
}

.btn.button-conclude {
  background: #E34263;
  color: #ffff;
  border-radius: 1.5px;
}

@media screen and (max-width: 720px) {
  .modal-content {
    height: auto !important; 
    width: 90vw;
  }
}


</style>